import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFallbackImage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 48,
	height: 48,
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2,
			d: "M35 14H13a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V15a1 1 0 0 0-1-1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2,
			d: "m12 29 6.288-6.288a1 1 0 0 1 1.424 0l5.576 5.576a1 1 0 0 0 1.424 0l2.576-2.576a1 1 0 0 1 1.424 0L36 31"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M27.5 22a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
		})
	]
});
export default SvgFallbackImage;
